import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { FieldOps } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: FieldOps = getDefaultState();

const namespaced: boolean = true;

export const fieldOps: Module<FieldOps, RootState> = {
	namespaced,
	state,
	actions,
	mutations
};